'use strict';
const cartHandler = require('./eventHandlers/cart');
const userHandler = require('./eventHandlers/user');

const handleBuiltInEvents = () => {
    $('body').on('product:afterAddToCart', function (e, data) {
        $('body').trigger('connectif:addToCart', data);
    });

    $('body').on('cart:update', function (e, data) {
        $('body').trigger('connectif:cartUpdate', data);
    });

    $('body').on('login:success', function (e, data) {
        $('body').trigger('connectif:userLogin', data);
    });
}

const registerEvents = () => {
    $('body').on('connectif:addToCart', cartHandler.handle);
    $('body').on('connectif:cartUpdate', cartHandler.handle);
    $('body').on('connectif:userLogin', userHandler.handle);
};

$(document).ready(() => {
    handleBuiltInEvents();
    registerEvents();
});